import { Navigate } from "react-router-dom";

function EmployeeProtectedRoute({ children }) {
  const isEmployeeLoggedIn = localStorage.getItem("emp_logged_in") === "true";

  if (!isEmployeeLoggedIn) {
    return <Navigate to="/employee-login" replace />;
  }

  return children;
}

export default EmployeeProtectedRoute;